export class ErgebnisQuelleGes {
    gesamtemissionen: number;
    emissionsschwerpunktX: number;
    emissionsschwerpunktY: number; 
    zusatzabstand: number;
    maximalerGewichtungsfaktor: number;

   }
 

   